import { LOGIN_MUTATION } from './login';
import { UPDATE_FILE, UPLOAD_FILE, DELETE_FILE_BY_ID } from './files';
import { PREVIEW_TOKEN_MUTATION } from './preview';

export default {
  LOGIN_MUTATION,
  UPDATE_FILE,
  UPLOAD_FILE,
  DELETE_FILE_BY_ID,
  PREVIEW_TOKEN_MUTATION
};
